var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScrollToTop = function SvgScrollToTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.129 52.406v73.54h377.748v-73.54zm0 293.85h152.085v161.33h73.606v-161.33h152.057L349.994 157.377z",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11.2
  })));
};
export default SvgScrollToTop;